import Layout from "app/core/layouts/Layout"
import { BlitzPage, Routes } from "@blitzjs/next"
import { useState } from "react"
import { Container, Box, Typography, Button } from "@mui/material"
import AddIcon from "@mui/icons-material/Add"
import Link from "next/link"
import AbExperimentControls, {
  QueryParams,
} from "app/abExperiments/components/AbExperimentControls"
import AbExperimentList from "app/abExperiments/components/AbExperimentList"
import { max, subDays } from "date-fns"

// Constants
const AGGREGATED_SINCE = new Date("2023-01-01")

const AbExperimentsPage: BlitzPage = () => {
  const [queryParams, setQueryParams] = useState<QueryParams>({
    orderBy: { id: "asc" },
    where: {},
  })

  return (
    <Container maxWidth={false}>
      <Box
        sx={{
          m: 1,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ my: 4 }} variant="h4" component="h2">
          AB Experiments
        </Typography>

        <Box sx={{ display: "flex", flexDirection: { md: "row", xs: "column" }, gap: 2 }}>
          <Link href="/abExperiments/new" legacyBehavior>
            <Button variant="contained" startIcon={<AddIcon />}>
              Create
            </Button>
          </Link>
        </Box>
      </Box>

      <AbExperimentControls queryParams={queryParams} setQueryParams={setQueryParams} />

      <AbExperimentList queryParams={queryParams} />
    </Container>
  )
}

AbExperimentsPage.authenticate = true
AbExperimentsPage.getLayout = (page) => <Layout title="AB Experiments">{page}</Layout>

export default AbExperimentsPage
